const STORAGE_KEY = "collectdiv_display_options";

const DEFAULT_OPTIONS = {
  hideProductDetails: false,
};

export function loadDisplayOptions() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      return { ...DEFAULT_OPTIONS, ...parsed };
    }
  } catch (_) {
    /* ignore */
  }
  return { ...DEFAULT_OPTIONS };
}

export function saveDisplayOptions(options) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(options));
}
